import { useContext } from "react"
import { MAX_PRODUCT_PRICE } from "../../config"
import { Context } from "../../store/store"
import ElemInput from "../elements/Input"
import ElemCheckbox from "../elements/Checkbox"
import React from "react"
import ElemCheckboxProducts from "../elements/CheckboxProducts"

interface ProductsProps {
	formElementChanged: Function
	validation: Object
}
const Product: React.FC<ProductsProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<section className="mx-auto max-w-[900px] px-6 md:px-0">

			<div className="mx-auto mb-1 grid max-w-[900px] grid-cols-1 items-start gap-1 lg:grid-cols-[1fr_1fr] lg:gap-5">
				<ElemInput
					label={"Produktpreis*"}
					props={{
						type: "number",
						step: "0.01",
						min: "0.1",
						max: MAX_PRODUCT_PRICE,
						name: "purchaseAmount",
						value: globalState.purchaseAmount,
						placeholder: "Produktpreis*",
						required: "required",
						onChange: e => formElementChanged(e, "purchaseAmount"),
					}}
					hasError={validation["invalid_purchaseAmount"] ? true : false}
					className="col-span-2 lg:col-span-1"
					suffix="EUR"
					errMsg={validation["invalid_purchaseAmount_errMsg"] || "Bitte Produktpreis eingeben. (max. 2,40 EUR)"}
				/>
				<ElemInput
					label={"Kaufdatum*"}
					props={{
						type: "date",
						name: "purchaseDate",
						value: globalState.purchaseDate,
						required: "required",
						placeholder: "Kaufdatum*",
						min: "2026-01-05",
						max: "2026-05-08",
						minLength: 1,
						onChange: e => formElementChanged(e, "purchaseDate"),
					}}
					// TODO: Datepicker
					hasError={validation["invalid_purchaseDate"] ? true : false}
					className="col-span-2 lg:col-span-1"
					errMsg={validation["invalid_purchaseDate_errMsg"] || "Bitte Kaufdatum eingeben."}
				/>
			</div>
		</section>
	)
}

export default Product
